export default {
  isShowFormLayer (state) { return state.showFormLayer }
}
